import { Shield, ArrowRight, CheckCircle, Smartphone } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TwoFactorSetupModal } from '@/features/settings/components/TwoFactorSetupModal';

interface TwoFactorRequiredPromptProps {
  onSetup?: () => void;
}

export const TwoFactorRequiredPrompt = (_props: TwoFactorRequiredPromptProps) => {
  const { t } = useTranslation();
  const [showSetupModal, setShowSetupModal] = useState(false);

  const handleSetupSuccess = () => {
    // Reload pour rafraîchir l'état 2FA et les données
    window.location.reload();
  };

  return (
    <>
      <div className="w-full max-w-md rounded-xl border border-neutral-200 bg-white">
        {/* Header */}
        <div className="border-b border-neutral-200 p-6">
          <div className="flex items-center gap-4">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-50">
              <Shield className="h-6 w-6 text-primary-600" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-neutral-900">
                {t('vault.twoFactorRequired.title')}
              </h2>
              <p className="text-sm text-neutral-500">
                {t('vault.myVault.security.title')}
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="mb-6 text-sm text-neutral-600">
            {t('vault.twoFactorRequired.description')}
          </p>

          {/* Benefits list */}
          <div className="mb-6 space-y-3">
            <div className="flex items-start gap-3">
              <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-success-500" />
              <span className="text-sm text-neutral-700">
                {t('vault.twoFactorRequired.reason1')}
              </span>
            </div>
            <div className="flex items-start gap-3">
              <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-success-500" />
              <span className="text-sm text-neutral-700">
                {t('vault.twoFactorRequired.reason2')}
              </span>
            </div>
            <div className="flex items-start gap-3">
              <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-success-500" />
              <span className="text-sm text-neutral-700">
                {t('vault.twoFactorRequired.reason3')}
              </span>
            </div>
          </div>

          {/* Action button */}
          <button
            type="button"
            onClick={() => setShowSetupModal(true)}
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-700"
          >
            {t('vault.twoFactorRequired.configure')}
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>

        {/* Footer */}
        <div className="border-t border-neutral-200 bg-neutral-50 px-6 py-4">
          <div className="flex items-start gap-3 text-xs text-neutral-600">
            <Smartphone className="mt-0.5 h-4 w-4 flex-shrink-0 text-neutral-400" />
            <p>{t('vault.twoFactorRequired.helpText')}</p>
          </div>
        </div>
      </div>

      {/* 2FA Setup Modal */}
      <TwoFactorSetupModal
        isOpen={showSetupModal}
        onClose={() => setShowSetupModal(false)}
        enabled={false}
        onSuccess={handleSetupSuccess}
      />
    </>
  );
};
